import type { Schemas } from "#shopware";

export function _useCustomProductConfigurator(quantity: Ref<number>) {
  const { product } = useProduct();

  const { unitPrice } = useProductPrice(product);

  type SelectedProduct = {
    id: string | undefined;
    quantity: number;
    productNumber: string;
    cover: Schemas["Media"] | undefined;
    name: string;
    unitPrice: number | undefined;
    type: string;
  };

  const selectedProducts = ref<SelectedProduct[]>([]);

  const additionalPrice = computed(() =>
    selectedProducts.value
      .filter((p) => p.id !== product.value?.id)
      .reduce((acc, p) => acc + (p.unitPrice || 0) * p.quantity, 0)
  );

  const totalPrice = computed(() =>
    selectedProducts.value.reduce(
      (acc, p) => acc + (p.unitPrice || 0) * p.quantity,
      0
    )
  );

  const addProduct = (product: SelectedProduct) => {
    product.quantity = quantity.value;
    selectedProducts.value = [...selectedProducts.value, product];
  };

  const removeItem = (id: string) => {
    selectedProducts.value = selectedProducts.value.filter((p) => p.id !== id);
  };

  watch(
    () => quantity.value,
    () => {
      selectedProducts.value.forEach((p) => {
        p.quantity = quantity.value;
      });
    }
  );

  const clear = () => {
    selectedProducts.value = [];
    quantity.value = 1;
    addProduct({
      id: product.value?.id,
      quantity: quantity.value,
      cover: product.value?.cover?.media,
      name: product.value?.translated?.name,
      unitPrice: unitPrice.value,
      productNumber: product.value?.productNumber,
      type: "product",
    });
  };

  return {
    selectedProducts,
    additionalPrice,
    totalPrice,
    addProduct,
    removeItem,
    clear,
  };
}

export const useCustomProductConfigurator = createSharedComposable(
  _useCustomProductConfigurator
);
